module.exports = __webpack_public_path__ + "img/fortuneOx.1acc18e3.jpeg";